module.exports = __webpack_public_path__ + "img/icon-facts.ce96efb1.svg";